import React from 'react';

const ErrorState = ({ message }) => (
  <div className="chart-state chart-state-error" role="alert">
    <p>{message}</p>
  </div>
);

export default ErrorState;
